import React from "react";
import {useTranslate} from "../../../../hooks/translate.hook";
import {Space} from "antd";
import {ComponentPropsFromRoute} from "../../../../routers/routers";
import {RouteButtons} from "../../../common/route-tabs/route.buttons";

export const HealthCenterSettings: React.FC<ComponentPropsFromRoute> = ({routeChildren}) => {

    const t = useTranslate();

    return (
        <Space direction="vertical" size={[0, 0]}>
            <RouteButtons routes={routeChildren!} />
        </Space>
    );
};
